import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { AppStateProvider } from './redux/AppStore';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';

/* Font Awesome */
import "../node_modules/@fortawesome/fontawesome-free/css/all.css";

/* Bootstrap */
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";

import './style.css';

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <AppStateProvider>
        <Provider store={store}>
          <CssBaseline />
          <App />
        </Provider>
      </AppStateProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
